import * as z from 'zod';

import { paginatedResponseSchema } from '@/_schemas/generic/paginated-response';
import { statusQuerySchema } from '@/_schemas/status-input';

import { billingSystemQueryLinkerSchema } from './billing-system-query-linker-schema';

export const billingSystemQuerySchema = z.object({
  ...billingSystemQueryLinkerSchema.shape,
  status: statusQuerySchema,
  clients_count: z.number(),
});

export type BillingSystemQuerySchema = z.infer<typeof billingSystemQuerySchema>;

export const billingSystemQueryAllSchema = paginatedResponseSchema(billingSystemQuerySchema);
export type BillingSystemQueryAllSchema = z.infer<typeof billingSystemQueryAllSchema>;
